"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_ROUTE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const RootElement_1 = __importDefault(require("../RootElement"));
const ErrorPage_1 = __importDefault(require("../ErrorPage"));
// import DashboardOld from '../DashboardOld';
const Dashboard_1 = __importDefault(require("../Dashboard"));
const Profile_1 = __importDefault(require("../Profile"));
const Settings_1 = __importDefault(require("../Settings"));
const Users_1 = __importDefault(require("../Users"));
const UserReport_1 = __importDefault(require("../UserReport"));
const UserReportList_1 = __importDefault(require("../UserReportList"));
const Courses_1 = __importDefault(require("../Courses"));
const CheckList_1 = __importDefault(require("../CheckList"));
const StudyPlanDesign_1 = __importDefault(require("../StudyPlanDesign"));
const CollegeLink_1 = __importDefault(require("../CollegeLink"));
const EssayPrompts_1 = __importDefault(require("../EssayPrompts"));
const ParentStudentGoal_1 = __importDefault(require("../ParentStudentGoal"));
const Activities_1 = __importDefault(require("../Activities"));
const ExtraCurricularActReport_1 = __importDefault(require("../ExtraCurricularActReport"));
const DesmosMain_1 = __importDefault(require("../DesmosMain"));
const DesmosMainNonSub_1 = __importDefault(require("../DesmosMainNonSub"));
const DesmosSpreadsheet_1 = __importDefault(require("../DesmosSpreadsheet"));
const DesmosPreview_1 = __importDefault(require("../DesmosPreview"));
const Subscriptions_1 = __importDefault(require("../Subscriptions"));
const MySubscription_1 = __importDefault(require("../MySubscription"));
const ManageQuestions_1 = __importDefault(require("../ManageQuestions"));
const UploadSat_1 = __importDefault(require("../UploadSat"));
const FlaggedQuestions_1 = __importDefault(require("../FlaggedQuestions"));
const TutorMonthlySession_1 = __importDefault(require("../TutorMonthlySession"));
exports.DASHBOARD_ROUTE = [
    {
        path: '',
        element: (0, jsx_runtime_1.jsx)(RootElement_1.default, {}),
        errorElement: (0, jsx_runtime_1.jsx)(ErrorPage_1.default, {}),
        children: [
            {
                index: true,
                element: (0, jsx_runtime_1.jsx)(Dashboard_1.default, {}),
            },
            {
                path: 'profile',
                element: (0, jsx_runtime_1.jsx)(Profile_1.default, {}),
            },
            {
                path: 'profile/:userId',
                element: (0, jsx_runtime_1.jsx)(Profile_1.default, {}),
            },
            {
                path: 'users',
                element: (0, jsx_runtime_1.jsx)(Users_1.default, {}),
            },
            {
                path: 'reports/:userId',
                element: (0, jsx_runtime_1.jsx)(UserReportList_1.default, {}),
            },
            {
                path: 'excurricular-report/:userId',
                element: (0, jsx_runtime_1.jsx)(ExtraCurricularActReport_1.default, {}),
            },
            {
                path: 'user-report/*',
                element: (0, jsx_runtime_1.jsx)(UserReport_1.default, {}),
            },
            {
                path: 'setting',
                element: (0, jsx_runtime_1.jsx)(Settings_1.default, {}),
            },
            {
                path: 'courses',
                element: (0, jsx_runtime_1.jsx)(Courses_1.default, {}),
            },
            {
                path: 'manage-questions/*',
                element: (0, jsx_runtime_1.jsx)(ManageQuestions_1.default, {}),
            },
            {
                path: 'checklist/:userId',
                element: (0, jsx_runtime_1.jsx)(CheckList_1.default, {}),
            },
            {
                path: 'studyplan/:userId',
                element: (0, jsx_runtime_1.jsx)(StudyPlanDesign_1.default, {}),
            },
            {
                path: 'collegeinfo',
                element: (0, jsx_runtime_1.jsx)(CollegeLink_1.default, {}),
            },
            {
                path: 'subscriptions/:userId',
                element: (0, jsx_runtime_1.jsx)(Subscriptions_1.default, {}),
            },
            {
                path: 'my-subscriptions/:userId',
                element: (0, jsx_runtime_1.jsx)(MySubscription_1.default, {}),
            },
            {
                path: 'essayprompts',
                element: (0, jsx_runtime_1.jsx)(EssayPrompts_1.default, {}),
            },
            {
                path: 'goals/:userId',
                element: (0, jsx_runtime_1.jsx)(ParentStudentGoal_1.default, {}),
            },
            {
                path: 'activity/:userId',
                element: (0, jsx_runtime_1.jsx)(Activities_1.default, {}),
            },
            {
                path: 'desmos-main/:userId',
                element: (0, jsx_runtime_1.jsx)(DesmosMain_1.default, {}),
            },
            {
                path: 'desmos-main-non/:userId',
                element: (0, jsx_runtime_1.jsx)(DesmosMainNonSub_1.default, {}),
            },
            {
                path: 'desmos-spreadsheet/:userId',
                element: (0, jsx_runtime_1.jsx)(DesmosSpreadsheet_1.default, {}),
            },
            {
                path: 'desmos-preview/:userId',
                element: (0, jsx_runtime_1.jsx)(DesmosPreview_1.default, {}),
            },
            {
                path: 'uploadsat/:userId',
                element: (0, jsx_runtime_1.jsx)(UploadSat_1.default, {}),
            },
            {
                path: 'flaggedQuestions/:userId',
                element: (0, jsx_runtime_1.jsx)(FlaggedQuestions_1.default, {}),
            },
            {
                path: 'tutor-monthly-session',
                element: (0, jsx_runtime_1.jsx)(TutorMonthlySession_1.default, {}),
            },
        ],
    },
];
